import React from 'react';
import { CTAButton } from './CTAButton';
export function Hero() {
  return <section className="relative pt-12 pb-16 lg:pt-20 lg:pb-24 overflow-hidden bg-gradient-to-b from-rose-50 to-warm-50" data-id="element-31">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-32">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20" data-id="element-33">
          {/* Text Content */}
          <div className="w-full lg:w-1/2 text-center lg:text-left" data-id="element-34">
            <div className="inline-block px-4 py-1.5 mb-6 text-sm font-semibold tracking-wider text-rose-700 uppercase bg-rose-100 rounded-full" data-id="element-35">
              Guía rápida y honesta
            </div>

            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-warm-900 leading-tight mb-6" data-id="element-36">
              De <span className="text-rose-500 italic" data-id="element-37">"no me alcanza"</span> a{' '}
              <span className="text-rose-500 italic" data-id="element-38">
                "ya tengo mi primer ingreso extra"
              </span>
            </h1>

            <p className="text-lg sm:text-xl text-warm-800 mb-8 leading-relaxed max-w-2xl mx-auto lg:mx-0" data-id="element-39">
              Usando solo tu cel y sin cosas raras. 7 chambas digitales que
              puedes empezar en 7 días, aunque tengas cero experiencia y
              horarios locos.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start" data-id="element-40">
              <CTAButton onClick={() => document.getElementById('pricing')?.scrollIntoView({
              behavior: 'smooth'
            })} data-id="element-41">
                Quiero mi guía ahora
              </CTAButton>
            </div>

            <p className="mt-6 text-sm text-warm-600 flex items-center justify-center lg:justify-start gap-2" data-id="element-42">
              <span className="w-2 h-2 bg-green-500 rounded-full animate-pulse" data-id="element-43"></span>
              Sin OnlyFans • Sin Estafas • Sin Inglés Perfecto
            </p>
          </div>

          {/* Image */}
          <div className="w-full lg:w-1/2 relative" data-id="element-44">
            <div className="absolute inset-0 bg-rose-200 rounded-3xl transform rotate-3 scale-95 opacity-50 blur-xl" data-id="element-45"></div>
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/1dhEEACXLeTuuWmS8mGqro/ChatGPT_Image_27_nov_2025%2C_09_39_41_p.m..png" alt="Portada del libro Chamba Digital para Mexicanas" className="relative rounded-2xl shadow-2xl transform hover:scale-[1.02] transition-transform duration-500 mx-auto max-w-sm lg:max-w-md w-full" data-id="element-46" />
          </div>
        </div>
      </div>
    </section>;
}